import { Spin } from "antd";
import * as React from "react";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import { ICaseDecisionTypesPresenter } from "../../presenter/CaseDecisionTypesPresenter";
import CaseDecisionTypeGrid from "../components/CaseDecisionTypeGrid";

export interface Props extends PageProps {}
export interface State extends ICaseDecisionTypesPresenter {}

export default class CaseDecisionTypesPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      caseDecisionTypes,
      createCaseDecisionType,
      updateCaseDecisionType
    } = this.state;

    return (
      <Page {...this.props} className={"content-wrapper"}>
        {
          <Spin spinning={this.state.loaders.caseDecisionTypeLoader}>
            <CaseDecisionTypeGrid
              translate={translate}
              caseDecisionTypes={caseDecisionTypes}
              createCaseDecisionType={createCaseDecisionType}
              referenceLoader={this.state.loaders.caseDecisionTypeLoader}
              updateCaseDecisionType={updateCaseDecisionType}
            />
          </Spin>
        }
      </Page>
    );
  }
}
